export default __webpack_public_path__ + "static/tree_100-69c4eed950d76663d3944391ca494560.svg";